<template>
  <div id="tags-view-container" class="tags-view-container" ref="tabviewbox">
    <div class="icon-left" @click="leftmove">
      <i class="el-icon-caret-left"></i>
    </div>
    <div class="tags-box" ref="tagsBox">
      <scroll-pane
        ref="scrollPane"
        class="tags-view-wrapper"
        :style="tabsRemove"
      >
        <router-link
          v-for="tag in visitedViewsList"
          ref="tag"
          :key="tag.path"
          :class="isActive(tag) ? 'active' : ''"
          :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
          tag="span"
          class="tags-view-item"
          :style="activeStyle(tag)"
          @click.middle.native="!isAffix(tag) ? closeSelectedTag(tag) : ''"
          @contextmenu.prevent.native="openMenu(tag, $event)"
        >
          {{ tag.title }}
          <span
            v-if="!isAffix(tag)"
            @click.prevent.stop="closeSelectedTag(tag)"
          >
            <i class="el-icon-error"></i>
          </span>
        </router-link>
      </scroll-pane>
    </div>
    <div class="icon-right" @click="rightmove">
      <i class="el-icon-caret-right"></i>
    </div>
    <ul
      v-show="visible"
      :style="{ left: left + 'px', top: top + 'px' }"
      class="contextmenu"
      ref="tabmenu"
    >
      <li @click="refreshSelectedTag(selectedTag)">刷新页面</li>
      <li v-if="!isAffix(selectedTag)" @click="closeSelectedTag(selectedTag)">
        关闭当前
      </li>
      <li @click="closeOthersTags">关闭其他</li>
      <li @click="closeAllTags(selectedTag)">关闭所有</li>
    </ul>
  </div>
</template>

<script>
import ScrollPane from "./ScrollPane";
import path from "path";
export default {
  components: { ScrollPane },
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      affixTags: [],
      moveWidth: 0,
      marginLeft: 0,
      boxWidth: 0,
      widthArray: [],
    };
  },
  computed: {
    visitedViewsList() {
      return this.$store.state.tabView.visitedViewsList;
    },
    routes() {
      return this.$store.state.permission.routes;
    },
    tabsRemove() {
      return `transform:translateX(${
        this.moveWidth + "px"
      });transition-duration:0.2s;`;
    },
    // theme() {
    //   return this.$store.state.settings.theme;
    // }
  },
  watch: {
    $route() {
      this.addTags();
      this.moveToCurrentTag();
    },
    visible(value) {
      if (value) {
        document.body.addEventListener("click", this.closeMenu);
      } else {
        document.body.removeEventListener("click", this.closeMenu);
      }
    },
  },
  mounted() {
    this.initTags();
    this.addTags();
  },
  methods: {
    leftmove() {
      var width1 = this.$refs.tagsBox.clientWidth;
      var width2 = this.$refs.scrollPane.$el.clientWidth;
      if (width1 >= width2 || this.moveWidth >= 0) {
        this.moveWidth = 0;
        return;
      }
      this.moveWidth = this.moveWidth + width1 / 2;
    },

    rightmove() {
      var width1 = this.$refs.tagsBox.clientWidth;
      var width2 = this.$refs.scrollPane.$el.clientWidth;
      this.boxWidth = width1 / 2;
      if (width1 >= width2 || width2 + this.moveWidth < width1) {
        return;
      }
      this.moveWidth = -(-this.moveWidth + this.boxWidth);
    },
    isActive(route) {
      return route.path === this.$route.path;
    },
    activeStyle(tag) {
      if (!this.isActive(tag)) return {};
      // return {
      //   "background-color": this.theme,
      //   "border-color": this.theme
      // };
    },
    removeLeft() {
      // console.log(this.visitedViews);
    },
    isAffix(tag) {
      return tag.meta && tag.meta.affixType;
    },
    filterAffixTags(routes, basePath = "/") {
      let tags = [];
      routes.forEach((route) => {
        if (route.meta && route.meta.affixType) {
          const tagPath = path.resolve(basePath, route.path);
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            title:route.meta.anotherName,
            meta: { ...route.meta },
          });
        }
        if (route.children) {
          const tempTags = this.filterAffixTags(route.children, route.path);
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags];
          }
        }
      });
      return tags;
    },
    initTags() {
      const affixTags = (this.affixTags = this.filterAffixTags(
        this.$router.options.routes
      ));
      for (const tag of affixTags) {
        // Must have tag name
        if (tag.name) {
          this.$store.dispatch("tabView/addVisitedView", tag);
        }
      }
    },
    addTags() {
      const { name } = this.$route;
      const { meta } = this.$route;
      if (meta.showType == false) {
        return;
      }
      if (name) {
        this.$store.dispatch("tabView/addView", this.$route);
      }
      return false;
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag;
      this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.to.path === this.$route.path) {
            this.$refs.scrollPane.moveToTarget(tag);
            if (tag.to.fullPath !== this.$route.fullPath) {
              this.$store.dispatch("tabView/updateVisitedView", this.$route);
            }
            break;
          }
        }
      });
    },
    refreshSelectedTag(view) {
      this.$store.dispatch("tabView/delCachedView", view).then(() => {
        const { fullPath } = view;
        this.$nextTick(() => {
          this.$router.replace({
            path: fullPath,
          });
        });
      });
    },
    closeSelectedTag(view) {
      this.$store
        .dispatch("tabView/delView", view)
        .then(({ visitedViewsList }) => {
          if (this.isActive(view)) {
            this.toLastView(visitedViewsList, view);
          }
        });
    },
    closeOthersTags() {
      this.$router.push({
        path: this.selectedTag.path,
      });
      this.$store
        .dispatch("tabView/delOthersViews", this.selectedTag)
        .then(() => {
          this.moveToCurrentTag();
        });
    },
    closeAllTags(view) {
      this.$store
        .dispatch("tabView/delAllViews")
        .then(({ visitedViewsList }) => {
          if (this.affixTags.some((tag) => tag.path === this.$route.path)) {
            return;
          }
          this.toLastView(visitedViewsList, view);
        });
    },
    toLastView(visitedViewsList, view) {
      const latestView = visitedViewsList.slice(-1)[0];
      if (latestView) {
        this.$router.push(latestView.fullPath);
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === "Dashboard") {
          // to reload home page
          this.$router.replace({ path: "/redirect" + view.fullPath });
        } else {
          this.$router.push("/");
        }
      }
    },
    openMenu(tag, e) {
      const menuMinWidth = 105;
      const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
      const offsetWidth = this.$el.offsetWidth; // container width
      const maxLeft = offsetWidth - menuMinWidth; // left boundary
      const left = e.clientX + 20; // 15: margin right
      if (left-offsetLeft > maxLeft) {
        this.left = maxLeft;
      } else {
        this.left = left-offsetLeft;
      }
      this.top = e.clientY-55;
      this.visible = true;
      this.selectedTag = tag;
    },
    closeMenu() {
      this.visible = false;
    },
    handleScroll() {
      this.closeMenu();
    },
  },
};
</script>

<style lang="less" scoped>
.tags-box {
  width: calc(100% - 60px);
  overflow: hidden;
}
.tags-view-container {
  height: 39px;
  width: 100%;
  // padding: 0 30px;
  // margin-left: -20px;
  background: #fff;
  border-bottom: 1px solid #d8dce5;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
  .icon-left {
    float: left;
    // margin-left: -30px;
    width: 19px;
    height: 39px;
    line-height: 39px;
    border-right: solid 1px #eee;
    padding-left: 10px;
    cursor: pointer;
    .el-icon-caret-left {
      margin-left: -5px;
    }
  }
  .icon-right {
    float: right;
    width: 19px;
    height: 39px;
    // margin-right: -30px;
    margin-top: -39px;
    line-height: 39px;
    border-left: solid 1px #eee;
    padding-right: 10px;
    cursor: pointer;
    .el-icon-caret-right {
      margin-left: 5px;
    }
  }
  .icon-left:hover {
    background: #eee;
  }
  .icon-right:hover {
    background: #eee;
  }
  .tags-view-wrapper {
    .tags-view-item {
      display: inline-block;
      position: relative;
      cursor: pointer;
      border-right: solid 1px #eee;
      height: 39px;
      line-height: 39px;
      color: #495060;
      background: #fff;
      padding: 0 15px;
      font-size: 14px;
      &:first-of-type {
        margin-left: 0px;
      }
      &:last-of-type {
        margin-right: 15px;
      }
      &.active {
        background-color: #ddd;
        color: #23508e;
        border-color: #ddd;
      }
      .el-icon-error {
        font-size: 14px;
        border-radius: 50%;
        color: #bbb;
      }
      .el-icon-error:hover {
        background-color: #fff;
        color: #ed5565;
      }
    }
  }
  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;
      &:hover {
        background: #eee;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TabView.vue